var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5350_66118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1017 4.92188L7.3145 13.7091L3.32031 9.71489",
    stroke: "#156CFE",
    strokeWidth: 2.55628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1017 5.23438L7.3145 14.0216L3.32031 10.0274",
    stroke: "#156CFE",
    strokeWidth: 2.55628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5350_66118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1721,
    height: 19.1721,
    fill: "white",
    transform: "translate(0.125 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCheck);
export default __webpack_public_path__ + "static/media/rightCheck.2263d422381b8c4b1c090aee79f48245.svg";
export { ForwardRef as ReactComponent };